<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="24" class="item">
                <el-card class="box-card" shadow='never'>
                  <div slot="header" class="clearfix">
                    <span>{{schedulName1}}</span>
                  </div>
                  <el-col :span="24" class="item">
                    <el-form-item label="早餐菜品"  required prop="nurseCodeArr1">
                      <el-select
                          v-model="addForm.nurseCodeArr1"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择早晨菜品">
                        <el-option
                            v-for="item in dishesList"
                            :key="item.dishesCode"
                            :label="item.name"
                            :value="item.dishesCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                </el-card>
              </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
                <el-card class="box-card" shadow='never'>
                  <div slot="header" class="clearfix">
                    <span>{{schedulName2}}</span>
                  </div>
                  <el-col :span="24" class="item">
                    <el-form-item label="午餐菜品" required prop="nurseCodeArr2">
                      <el-select
                          v-model="addForm.nurseCodeArr2"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择午餐菜品">
                        <el-option
                            v-for="item in dishesList"
                            :key="item.dishesCode"
                            :label="item.name"
                            :value="item.dishesCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-card>
              </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
                <el-card class="box-card" shadow='never'>
                  <div slot="header" class="clearfix">
                    <span>{{schedulName3}}</span>
                  </div>
                  <el-col :span="24" class="item">
                    <el-form-item label="晚餐菜品"  required prop="nurseCodeArr3">
                      <el-select
                          v-model="addForm.nurseCodeArr3"
                          multiple
                          style="width:100%"
                          filterable
                          placeholder="请选择晚餐菜品">
                        <el-option
                            v-for="item in dishesList"
                            :key="item.dishesCode"
                            :label="item.name"
                            :value="item.dishesCode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-card>
              </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'Add',
  props:['dishesList'],
  data() {
    return {
      loading: false,

      schedulName1:'早餐',
      schedulName2:'午餐',
      schedulName3:'晚餐',


      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        timeArr:[],

        nurseCodeArr1:[],
        nurseCodeArr2:[],
        nurseCodeArr3:[],

        dishesPlan:{},

      },

      pickerOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      rules:{
        time:[
          { required: true, message: '请选择时间', trigger: 'blur' },
        ],

        nurseCodeArr1:[{ required: true, message: '请选择早晨菜品', trigger: 'blur' },
          { required: true, message: '请选择早晨菜品', trigger: 'change' }],
        nurseCodeArr2:[{ required: true, message: '请选择午餐菜品', trigger: 'blur' },
          { required: true, message: '请选择午餐菜品', trigger: 'change' }],
        nurseCodeArr3:[{ required: true, message: '请选择晚餐菜品', trigger: 'blur' },
          { required: true, message: '请选择晚餐菜品', trigger: 'change' }],

      }

    }
  },

  methods: {
    init(dateList){
      this.$refs.addForm.resetFields();

      this.addForm.timeArr=dateList
    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.addForm.dishesPlan = {};
      this.addForm.dishesPlan.morningPlan = this.addForm.nurseCodeArr1;
      this.addForm.dishesPlan.noonPlan = this.addForm.nurseCodeArr2;
      this.addForm.dishesPlan.nightPlan = this.addForm.nurseCodeArr3;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"DishesPlan/BusinessAddMany",
        data: this.addForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          })
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
